import {Button, Card, CardContent, CardActions, Typography} from "@mui/material"
import { QueryBuilderRounded } from "@mui/icons-material"
import React from "react"
import "./styles.scss"
import { useNavigate } from "react-router-dom"

function CardBlock(props) {
  const navigate = useNavigate()

  const openDetailsPage = (id) => {
    navigate(`/journaledit/${id}/0`)
  }

  console.log('card')
  return (
    <>
      <div className="details-block">
        <h2>{props.title}</h2>
        <Card>
          <CardContent>
            <div className="groups-wrapper">
              {props.data?.map((el, index) => {
                return el.groups.sort((l,r) => l > r ? 1 : -1).map(group => {
                  return <div className="group" key={index}>
                    {group} {el.deletedByUmu ? <span style={{'color': 'red'}}>Удалено</span> : ''}
                  </div>
                })
              })}
            </div>
          </CardContent>
          <CardActions>
            <div className="card-action">
              <div className="time-wrapper">
                <div className="icon-block">
                  <QueryBuilderRounded />
                  {props.data[0]?.filledHours} / {props.data[0]?.totalHours}
                </div>
              </div>
              <div className="action-wrapper">
                <Button variant="text"
                        disabled={props.data[0]?.filledHours >= props.data[0]?.totalHours}
                        onClick={()=>openDetailsPage(props.data[0]?.groupFlowTeamId)}>
                  Открыть
                </Button>
              </div>
            </div>
          </CardActions>
        </Card>
      </div>
    </>
  )
}

export default CardBlock
